<ng-container *ngIf="modelRemuneration">
  <h3 class="mb-3">Resumen de productos</h3>
  <div class="table-responsive-lg">
    <table class="table table-vcenter data-tables responsive w-100 table__resume">
      <thead>
        <tr>
          <th colspan="1" class="bg-transparent border-bottom-0"></th>
          <th colspan="3" class="bg-dark text-white bold">Nivel conseguido</th>
          <th colspan="2" class="bg-darkgrey bold" *ngIf="isOpen">Siguiente nivel</th>
        </tr>
        <tr>
          <th class="bg-primary">Producto</th>
          <th class="bg-primary">Total Unidades</th>
          <th class="bg-primary">€/Ud.</th>
          <th class="bg-primary">Total €</th>
          <th class="bg-primary" *ngIf="isOpen">Unidades</th>
          <th class="bg-primary" *ngIf="isOpen">€/Unidad</th>
        </tr>
      </thead>
      
      <tbody>
        <tr *ngFor="let elem of modelRemuneration.DataList">
          <td class="bold text-left">{{elem.ProductType}}</td>
          <td class="bg-lightgrey">{{elem.TotalUnits}}</td>
          <td class="bg-lightgrey">{{elem.Price | currency:'EUR'}}</td>
          <td class="bg-lightgrey">{{elem.TotalPrice | currency:'EUR'}}</td>
          <td *ngIf="isOpen"><span *ngIf="elem.NextLevelUnits > 0">{{elem.NextLevelUnits}}</span></td>
          <td *ngIf="isOpen"><span *ngIf="elem.NextLevelUnits > 0">{{elem.NextLevelPrice | currency:'EUR'}}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>